export default __webpack_public_path__ + "static/media/slide17.3e4e0686.png";